import $ from 'cash-dom';
import ResizeSensor from 'css-element-queries/src/ResizeSensor';
import StickySidebar from 'sticky-sidebar';
export default function () {
  let stickySidebar;
  if ($('.js-annual10k__sticky').length) {
    stickySidebar = new StickySidebar('.js-annual10k__sticky', {
      topSpacing: 0,
      bottomSpacing: 0,
      containerSelector: '.js-annual10k__stickyContainer',
      innerWrapperSelector: '.js-annual10k__stickyInner'
    });
  }
  const $accordions = $('.lf-accordion');
  if ($accordions) {
    $accordions.each((_, accordion) => {
      const $accordion = $(accordion);
      $('.lf-accordion-toggle', $accordion).each((_, toggle) => {
        const $toggle = $(toggle);
        const $content = $($toggle.data('contentSelector'));
        if (!$toggle.hasClass('active') && $toggle.find('active').length === 0) {
          $content.css('max-height', 0);
        }
        if ($('.js-annual10k__sticky').length) {
          stickySidebar.updateSticky();
        }
        $(window).on('resize', () => {
          const $content = $($toggle.data('contentSelector'));
          const $children = $content.children();
          if ($toggle.hasClass('active')) {
            $content.css('max-height', Object.values($children).reduce((total, selector) => total + $(selector).outerHeight(true), 0) // Calculates height of the children
            );
          }
          if ($('.js-annual10k__sticky').length) {
            stickySidebar.updateSticky();
          }
        });
        $toggle.on('click', e => {
          e.preventDefault();
          $toggle.toggleClass('active');
          const $content = $($toggle.data('contentSelector'));
          if ($content.height() !== 0) {
            $content.css('max-height', 0);
          } else {
            const $children = $content.children();
            delete $children.length; // for summation of height
            $content.css('max-height', Object.values($children).reduce((total, selector) => total + $(selector).outerHeight(true), 0) // Calculates height of the children
            );
          }
          if ($('.js-annual10k__sticky').length) {
            stickySidebar.updateSticky();
          }
        });
      });
    });
  }
}